export enum ModalId {
  AddCoApplicant,
  EditCoApplicant,
  SoftPull
}

export const ModalPriorities = {
  [ModalId.SoftPull]: 1
};

export enum NativeModalId {
  SoftPull = 'softpull'
}
